import { googleLogout } from '@react-oauth/google';
import { clearSession } from 'utils/auth';

// Kept for backwards compat: Header still calls useGoogle({}).signOut() on
// logout. The Google Identity Services session is per-tab and revocation is
// best-effort; we always clear our own JWT regardless.
function useGoogle() {
  function signOut() {
    try {
      googleLogout();
    } catch (e) {
      /* ignore */
    }
    clearSession();
  }
  return { signIn: () => {}, signOut };
}

export default useGoogle;
